// src/theme.ts
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
    styles: {
        global: {
            body: {
                //margin: 0,
                //padding: 0,
                //boxSizing: 'border-box',
            },
        },
    },
    colors: {
        brand: {
            gradient: 'linear(to-r, #FE01DC, #1799D6)',  // Dégradé personnalisé
        },
        pink: '#FE01DC',
        blue: '#1799D6',
        bgBodycolor: '#fff',
    },
});

export default theme;
